<template>
  <div class="card">
    <div class="card-header text-center"></div>
    <form id="transactionForm" class="form-horizontal">
      <div class="card-content">
        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Business Name *</label>
            <div class="col-sm-6">
              <input type="text"
                    name="businessName"
                    data-vv-as="Business Name"
                    v-validate="modelValidations.businessName"
                    v-model="model.businessName"
                    class="form-control">
              <small class="text-danger" v-show="businessName.invalid">
                {{ getError('businessName') }}
              </small>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <label class="col-sm-3 control-label">Name on Bank Narration*</label>
            <div class="col-sm-6">
              <input type="text"
                    name="narrationName"
                    data-vv-as="Name on Bank Narration"
                    v-validate="modelValidations.narrationName"
                    v-model="model.narrationName"
                    class="form-control">
              <small class="text-danger" v-show="narrationName.invalid">
                {{ getError('narrationName') }}
              </small>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <label class="col-sm-3 control-label">General Reward Point(%)*</label>
            <div class="col-sm-6">
              <input type="number"
                    name="generalPoint"
                    min="1" max="100"
                    data-vv-as="General Reward Point"
                    v-validate="modelValidations.generalPoint"
                    v-model="model.generalPoint"
                    class="form-control">
              <small class="text-danger" v-show="generalPoint.invalid">
                {{ getError('generalPoint') }}
              </small>
            </div>
          </div>
        </fieldset>

      </div>
      <div class="card-footer">
        <p-button type="info" @click.prevent="validate" class="info" round>{{ model.saveRewardButtonText }}</p-button>
      </div>
    </form>

  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker, TimePicker, Slider, Tag, Input, Button, Select, Option} from 'element-ui'

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Option.name]: Option,
      [Select.name]: Select,
    },
    computed: {
      ...mapFields(['businessName', 'narrationName', 'generalPoint'])
    },
    data () {
      return {
        model: {
          businessName: '',
          narrationName: '',
          generalPoint: '',
          saveRewardButtonText: 'Save Reward'
        },
        modelValidations: {
          businessName: {
            required: true
          },
          narrationName: {
            required: true,
            decimal: true
          },
          generalPoint: {
            required: true,
          },
        },
        
        
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      enterPressed (e) {
        if(e.key == 'Enter') {
          this.validate()
        }
      },

      validate () {
        this.$validator.validateAll().then(isValid => {
          if(isValid){
            this.$emit('on-submit', this.model, isValid, this.$validator)
          }
        })
      },

    },

    
    created: function () {
      window.addEventListener('keyup', this.enterPressed)
    },

    beforeDestroy () {
      window.removeEventListener('keyup', this.enterPressed)
    }
  }
</script>
<style>
  #transactionForm .el-select { display: block  !important;}
</style>